import React, { useState } from 'react';
import Modal, { Body, Header } from 'src/@vymo/ui/blocks/modal';
import { DocPreview } from 'src/@vymo/ui/molecules';
import { useAppDispatch } from 'src/store/hooks';
import { setSelectedTileData } from '../slice';
import { ShowTextActionProps } from '../types';
import styles from '../index.module.scss';

function ShowTextAction({
  action,
  widgetCode,
}: ShowTextActionProps): JSX.Element | null {
  const [open, setOpen] = useState(true);
  const dispatch = useAppDispatch();

  const onCloseHandler = () => {
    setOpen(false);
    dispatch(setSelectedTileData({ widgetCode, data: {} }));
  };

  if (action.render_type === 'HTML') {
    return (
      <Modal
        classNames={styles.spg__modal}
        open={open}
        showCloseButton
        closeOnEscape
        onClose={onCloseHandler}
      >
        <Header>
          <h2>{action.title}</h2>
        </Header>
        <Body>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: action.content_data.html,
            }}
          />
        </Body>
      </Modal>
    );
  }

  if (action.render_type === 'JSON') {
    const blob = new Blob([action.content_data.json || ''], {
      type: 'application/json',
    });
    const file = new File([blob], 'data.json', {
      type: 'application/json',
    });
    return (
      <DocPreview open={open} onClose={onCloseHandler} document={{ file }} />
    );
  }

  return (
    <Modal
      open={open}
      showCloseButton
      closeOnEscape
      onClose={onCloseHandler}
      classNames={styles.spg__modal}
    >
      <Header>
        <h2>{action.title}</h2>
      </Header>
      <Body>{action.content_data.plain}</Body>
    </Modal>
  );
}

export default ShowTextAction;
